import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/promo/checkout/status/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts >= 6) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (err) {
        setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F3F0EA] flex items-center justify-center p-6" data-testid="payment-success-page">
      <div className="bg-white rounded-3xl border border-black/5 shadow-md p-10 max-w-md w-full text-center">
        {status === "pending" && (
          <>
            <Loader2 size={48} className="mx-auto text-[#E26D5C] animate-spin"/>
            <h1 className="font-display font-black text-2xl mt-4">Vérification du paiement…</h1>
            <p className="text-[#5C6B55] mt-2">Merci de patienter quelques instants.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={48} className="mx-auto text-[#4CAF50]"/>
            <h1 className="font-display font-black text-3xl mt-4" data-testid="payment-success-title">Paiement confirmé !</h1>
            <p className="text-[#5C6B55] mt-2">Votre établissement est désormais boosté. Bonne visibilité !</p>
            <Link to="/merchant"><Button className="mt-6 rounded-full bg-[#E26D5C] hover:bg-[#D15B4A]" data-testid="back-merchant-btn">Retour au tableau de bord</Button></Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle size={48} className="mx-auto text-red-500"/>
            <h1 className="font-display font-black text-2xl mt-4">Paiement non confirmé</h1>
            <p className="text-[#5C6B55] mt-2">Une erreur est survenue ou la session a expiré.</p>
            <Link to="/merchant"><Button variant="outline" className="mt-6 rounded-full">Retour</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
